// extracted by css-extract-rspack-plugin
module.exports =  {"label":"Label__label--IVHDv","required":"Label__required--FyEnz"};